import { crv, cva } from '@/styled-system/css';

export const progressStepperStepLabelRecipe = cva({
  base: {
    'textWrap': 'balance',

    '& > .c11n_tag__root': {
      marginBlockStart: 'tightest',
    },
  },
  variants: {
    alignLabel: { center: {}, left: {} },
    orientation: { vertical: {}, horizontal: {} },
    ...crv('labelAppearance', {
      all: {
        'display': 'block',
        '&.c11n_progress-stepper__current-label': {
          display: 'none',
        },
      },
      current: {
        '&': {
          display: 'none',
        },

        '&.c11n_progress-stepper__current-label': {
          display: 'block',
        },

        '[data-orientation="vertical"] &': {
          display: 'block',
        },

        '[data-orientation="vertical"] &.c11n_progress-stepper__current-label': {
          display: 'none',
        },
      },
      none: {
        display: 'none',
      },
    }),
  },
  compoundVariants: [
    {
      orientation: 'vertical',
      alignLabel: ['center', 'left'],
      css: {
        textAlign: 'left',
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'left',
      css: {
        textAlign: 'left',
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'center',
      css: {
        textAlign: 'center',
      },
    },
  ],
});
